import { ref } from 'vue'

export function useModal() {
  const showModal = ref(false)
  const modalMode = ref('create') // 'create' or 'edit'

  const openCreateModal = () => {
    modalMode.value = 'create'
    showModal.value = true
  }

  const openEditModal = () => {
    modalMode.value = 'edit'
    showModal.value = true
  }

  const closeModal = () => {
    showModal.value = false
  }

  return {
    showModal,
    modalMode,
    openCreateModal,
    openEditModal,
    closeModal
  }
}